module.exports = __webpack_public_path__ + "resources/img/ukas.51946d18546ad3291a9679382c223a7c.png";